export default { sha: 'c95240e8a36444b24ada9ec999be5428b3c6bff6', buildNumber: 'undefined' }
